import { createContext, useContext, useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [adminRole, setAdminRole] = useState(null);
  const [adminStatus, setAdminStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setLoading(true);
      setUser(currentUser);
      setAdminRole(null);
      setAdminStatus(null);

      if (currentUser) {
        try {
          const roleSnap = await getDoc(doc(db, "adminUsers", currentUser.uid));

          if (roleSnap.exists()) {
            const data = roleSnap.data();
            const status = data.status || "active";

            if (status === "deactivated") {
              await signOut(auth);
              setUser(null);
              setAdminRole(null);
              setAdminStatus("deactivated");
            } else {
              setAdminRole(data.role || "moderator");
              setAdminStatus(status);
            }
          } else {
            await signOut(auth);
            setUser(null);
            setAdminRole(null);
            setAdminStatus("deactivated");
          }
        } catch (err) {
          console.error("Error loading admin role:", err);
          await signOut(auth);
          setUser(null);
          setAdminRole(null);
          setAdminStatus("deactivated");
        }
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logout = () => {
    return signOut(auth);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        adminRole,
        adminStatus,
        isSuperAdmin: adminRole === "superadmin",
        isAdminActive: adminStatus === "active",
        login,
        logout,
        loading,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}